define('quantitySelector/quantitySelector',[
],
function () {

    function init() {
        $(".quantity-selector .btn-minus").off("click").on("click", decreaseQuantity);
        $(".quantity-selector .btn-plus").off("click").on("click", increaseQuantity);
        $(".quantity-selector input").off("change").on("change", quantityChanged);
    }

    function decreaseQuantity(event) {
        changeQuantity(this, -1);
    }

    function increaseQuantity(event) {
        changeQuantity(this, 1);
    }

    function changeQuantity(clickedElement, delta) {
        var inputElement = $(clickedElement).closest(".quantity-selector").find("input");
        var quantity = parseInt($(inputElement).val());
        quantity += delta;
        inputElement.val(quantity).trigger("change");
    }

    function setQuantity(element, quantity, triggerChange) {
        var inputElement = $(element).closest(".quantity-selector").find("input");
        inputElement.val(quantity);
        if (triggerChange) {
            // this triggers other changes (validation and dispatching quantityChanged event)
            inputElement.trigger("change");
        }
    }

    function quantityChanged(event) {
        validateQuantity(this);
        dispatchQuantityChangedEvent(this);
    }

    function validateQuantity(element) {
        // validation of input value and enabling/disabling the minus/plus buttons
        var quantity = parseInt($(element).val());
        var minValue = parseInt($(element).data("minValue"));
        var maxValue = parseInt($(element).data("maxValue"));
        var minusButton = $(element).closest(".quantity-selector").find(".btn-minus");
        var plusButton = $(element).closest(".quantity-selector").find(".btn-plus");

        if (quantity < minValue || isNaN(quantity)) quantity = minValue;
        else if (quantity > maxValue) quantity = maxValue;

        $(element).val(quantity);   // do this always, for cases where user entered decimal value, to convert it to integer

        if (quantity <= minValue) $(minusButton).attr("disabled", "");
        else $(minusButton).attr("disabled", null);
        if (quantity >= maxValue) $(plusButton).attr("disabled", "");
        else $(plusButton).attr("disabled", null);
    }

    function dispatchQuantityChangedEvent(changedElement) {
        // Dispatches a custom event, so the consumers of this Quantity Selector can do some custom processing if they need to.

        // To avoid multiple events if the user is frantically clicking on the increase/decrease arrows,
        // we're only sending the event after there's been a quiet period of 1 second.

        if (changedElement.quantityChangedTimer) {
            // there's a timer in progress - kill it so we can start a new one.
            clearTimeout(changedElement.quantityChangedTimer);
            changedElement.quantityChangedTimer = null;
        }
        if (!changedElement.quantityChangedTimer) {
            changedElement.quantityChangedTimer = setTimeout(function () {
                var quantityChangedEvent = document.createEvent("Event");
                quantityChangedEvent.initEvent("quantityChanged", true, true);
                changedElement.dispatchEvent(quantityChangedEvent);
                changedElement.quantityChangedTimer = null;
            }, 1000);
        }
    }

    return {
        init: init,
        validateQuantity: validateQuantity,
        setQuantity: setQuantity
    };
});

